module.exports = __webpack_public_path__ + "static/media/features-tabs-icon-03.c03e4b12.svg";